import { ImmobileSituationInteractor, ImmobileSituationRequest, ImmobileSituationStructRequest } from "../../Coordinator/ImmobileSituation/ImmobileSituationInteractor";

export class ImmobileSituationViewModel {
    private interactor: ImmobileSituationInteractor;

	constructor() {
		this.interactor = new ImmobileSituationInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new ImmobileSituationRequest(
            obj["cgepsituacoesshape"] ? parseInt(obj["cgepsituacoesshape"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res()
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new ImmobileSituationStructRequest(
            obj["cgepsituacoesshape"] ? parseInt(obj["cgepsituacoesshape"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}